import * as React from 'react';
import { useGetList } from "react-admin";
import JobShow from '../jobs/JobShow';

const getExamplePublicJobs = (limit=10) => {
    const { data, isLoading, error } = useGetList(
        'public/example-jobs',
        {
            pagination: { page: 1, perPage: limit },
            sort: { field: 'id', order: 'DESC' }
        }
    );
    if (isLoading || error) {
        return null
    }
    const examplePublicJobsList = data.map(
        record => <JobShow key={`exampleJobs_${record.id}`} record={record} resource="public/jobs" />
    )
    return examplePublicJobsList;
};

export default getExamplePublicJobs;